module.exports = __webpack_public_path__ + "img/noimg.e0a1062c.png";